const GAP = 8;
export const HEIGHT = 208;
export const TOTAL_HEIGHT = HEIGHT + GAP;
